export default __webpack_public_path__ + "static/media/005-corythosaurus.a527e70d.svg";